module.exports = __webpack_public_path__ + "img/story-laravel.06356652.svg";